
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useStyles } from "../search/search";
import { Box, Button, Collapse, IconButton, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";
import YAML from 'json2yaml';
import { ArrowBack } from '@material-ui/icons';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import MuiAlert from '@material-ui/lab/Alert';


function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const AddressTableView = ({ customerId, searchedPlace, handleClose, setLoading }) => {

    const api = '/api/';
    const [instances, setInstances] = useState([]);
    const [columns, setColumns] = useState([]);
    const classes = useStyles();
    const [selectedPlace, setSelectedPlace] = useState(searchedPlace ?? null)

    const [fullWidthColumns, setFullWidthColumns] = useState([]);

    const [snackopen, setsnackOpen] = useState(false);
    const [snackMessage, setSnackMessage] = useState('');

    const handleCellClick = () => {
        setSnackMessage('Copied to clipboard!');
        setsnackOpen(true);
    };

    const handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setsnackOpen(false);
        setSnackMessage('');
    };

    const copyToClipboard = (row, columns) => {
        var jsonObject = {};
        columns.map((column) => (jsonObject[column] = row[column]));
        const ta = document.createElement('textarea');
        ta.innerText = YAML.stringify(jsonObject);
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        ta.remove();
        jsonObject = {};
        handleCellClick();
    };

    const copyText = (text) => {
        const ta = document.createElement('textarea');
        if (!text) return;
        ta.innerText = text;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        ta.remove();
        handleCellClick();
    };

    const toggleFullWidthColumns = (column) => {
        let currentFullWidthColumns = [...fullWidthColumns];
        if (currentFullWidthColumns.includes(column)) {
            currentFullWidthColumns.splice(currentFullWidthColumns.indexOf(column), 1);
        } else {
            currentFullWidthColumns.push(column);
        }

        setFullWidthColumns(currentFullWidthColumns);
    };

    const fetchSearchResults = async (data) => {
        try {
            setLoading(true);
            const url = api + 'address/search/compact/' + customerId;
            const response = await axios.post(url, data, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response?.data;
        } catch (error) {
            console.error("fetchSearchAddressResults error", error)
        } finally {
            setLoading(false)
        }
    }

    const handlePlaceSelect = async (place) => {
        setInstances([]);
        setColumns([]);

        const data = {
            "attributeSearchItems": [
                {
                    "attributeName": "Address",
                    "searchString": place.formatted_address,
                    "isGlobal": false,
                    "zipRadium": null,
                    "addressRadius": null
                }
            ],
            "sortInfo": {},
            "templateId": null
        }


        const response = await fetchSearchResults(data);


        var jsonResponse = response;
        var attributes = [];
        var result = {};
        let final = [];
        const ids = jsonResponse.map((item) => item.instance.id);

        for (var ele of ids) {
            attributes.push(jsonResponse.filter((value) => value.instance.id == ele));
        }

        var i = 0;
        const seenIds = new Set();
        while (i < attributes.length) {
            var names = [];
            var orderLookup = {};
            for (var val of attributes[i]) {
                names.push(val.templateAttribute.name);

                orderLookup[val.templateAttribute.name] = val.templateAttribute.order;
                result[val.templateAttribute.name] = val.content;
                result['Formatted Address'] = val?.address?.formattedAddress;
                result['Distance (miles)'] = val.miles;
                result['id'] = val.id;
            }
            i++;
            if (!seenIds.has(result["id"])) {
                seenIds.add(result["id"]);
                final.push(result);
            }
            result = {};
        }

        names?.push('Formatted Address');
        names?.push('Distance (miles)');

        final.sort((a, b) => a['Distance (miles)'] - b['Distance (miles)']);

        if (attributes.length !== 0) {
            setLoading(false);
            setTimeout(() => {
                setColumns(names);
                setInstances(final);
            }, 100);
        }

        setSelectedPlace(place)
    };


    useEffect(async () => {
        if (searchedPlace) {
            await handlePlaceSelect(searchedPlace);
        }
    }, [searchedPlace])

    return (
        <div style={{ padding: '10px' }}>
            <div className='address-map-sidebar-header'>
                <IconButton onClick={handleClose}><ArrowBack /></IconButton>
                <h2 style={{ flex: 2 }}>Link Search Address</h2>
            </div>
            <div style={{ paddingBottom: "25px" }}>
                <span className={classes.infoSpan}>* Click a cell to copy its contents</span>
            </div>
            <div className='address-map-section'>
                <p className='pointer' style={{ fontSize: "1.2rem", fontWeight: 500, color: "black", margin: 0 }} onClick={() => copyText(searchedPlace.formatted_address)}>
                    Searched Location: <span style={{ backgroundColor: "#ffffcc", padding: "2px 6px", borderRadius: "4px" }}>
                        {searchedPlace.formatted_address}
                    </span> | Coordinates:
                    <span style={{ fontWeight: "bold", marginLeft: "4px" }}>
                        {searchedPlace.geometry.location.lat().toFixed(4)}, {searchedPlace.geometry.location.lng().toFixed(4)}
                    </span>
                </p>
            </div>

            <Box>
                <Paper className={classes.wrap} elevation={3}>
                    {instances && instances.length === 0
                        ? 'No Data Available'
                        : ''}
                    <TableContainer sx={{ maxHeight: "90vh" }}>
                        <Table
                            stickyHeader
                            aria-label="sticky table"
                            onClick={(e) => {
                                e?.target?.nodeName === 'TH'
                                    ? toggleFullWidthColumns(e.target.innerText)
                                    : copyText(e.target.innerText);
                            }}
                        >
                            <TableHead>
                                <TableRow>
                                    {/* <TableCell></TableCell> */}
                                    {columns && instances &&
                                        instances.length !== 0 &&
                                        columns.map((column, i) => (
                                            <TableCell
                                                align="left"
                                                style={{
                                                    whiteSpace: 'nowrap',
                                                    cursor: 'pointer',
                                                    borderRight: '1px solid lightgrey',
                                                }}
                                                value={column}
                                            >
                                                <strong>{column}</strong>

                                            </TableCell>
                                        ))}
                                    {columns && instances && instances.length !== 0 && (
                                        <TableCell style={{ textAlign: 'center' }}><strong>Copy Row</strong></TableCell>
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {instances && instances.length !== 0
                                    ? instances.map((row) => {
                                        return (
                                            <>
                                                <TableRow hover role="checkbox" tabIndex={-1}>
                                                    {/* <TableCell>
                                                    </TableCell> */}
                                                    {columns.map((column) => (
                                                        <TableCell
                                                            align="left"
                                                            style={{
                                                                //maxWidth: fullWidthColumns.includes(column) ? 'none' : 100,
                                                                maxWidth: 100,
                                                                borderRight: '1px solid lightgray',
                                                            }}
                                                        >
                                                            {row !== null && row !== undefined && row !== '' ? (
                                                                <Typography
                                                                    style={{ cursor: 'pointer' }}
                                                                    noWrap
                                                                    variant="body2"
                                                                >
                                                                    {row[column]}
                                                                </Typography>
                                                            ) : (
                                                                'NA'
                                                            )}
                                                        </TableCell>
                                                    ))}
                                                    <TableCell>
                                                        <Button
                                                            startIcon={<FileCopyIcon />}
                                                            className={classes.btn}
                                                            color="default"
                                                            onClick={() => {
                                                                copyToClipboard(row, columns);
                                                            }}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell
                                                        style={{ paddingBottom: 0, paddingTop: 0 }}
                                                        colSpan={columns.length}
                                                    >
                                                        {/* <Collapse in={open == row.id} timeout="auto" unmountOnExit>
                                                            {columns.map((column) => (
                                                                <Box>
                                                                    {row[column] !== null &&
                                                                        row[column] !== undefined &&
                                                                        row[column] !== '' ? (
                                                                        row[column].length > 15 ? (
                                                                            <div className={classes.boxWrap}>
                                                                                <Typography
                                                                                    variant="subtitle1"
                                                                                    style={{ fontWeight: 'bold' }}
                                                                                >
                                                                                    {column}
                                                                                </Typography>
                                                                                <Typography variant="body2">{row[column]}</Typography>
                                                                            </div>
                                                                        ) : (
                                                                            ''
                                                                        )
                                                                    ) : (
                                                                        ''
                                                                    )}
                                                                </Box>
                                                            ))}
                                                        </Collapse> */}
                                                    </TableCell>
                                                </TableRow>
                                            </>
                                        );
                                    })
                                    : ''}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* <Box style={{ textAlign: 'center', margin: '10px', marginLeft: '40%' }}>
                        <Pagination
                            count={Math.ceil(searchResult.length / 10)}
                            page={page}
                            onChange={handlePageChange}
                        />
                    </Box> */}
                </Paper>
            </Box>


            <Snackbar open={snackopen} autoHideDuration={2000} onClose={handleSnackClose}>
                <Alert onClose={handleSnackClose} severity="success">
                    {snackMessage}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default React.memo(AddressTableView);